import { render, staticRenderFns } from "./dataAnalysisDetail.vue?vue&type=template&id=54fe5b56&scoped=true&"
import script from "./dataAnalysisDetail.vue?vue&type=script&lang=js&"
export * from "./dataAnalysisDetail.vue?vue&type=script&lang=js&"
import style0 from "./dataAnalysisDetail.vue?vue&type=style&index=0&id=54fe5b56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe5b56",
  null
  
)

export default component.exports